/**
 * The resume row's thumbnail box, shared with `CoursesHomeSkeleton` so the
 * pending row is the loaded row's height. Full width and 16:9 stacked above
 * the text below `@md`; a fixed 160px column beside it from there up.
 */
export const RESUME_THUMB = 'w-full shrink-0 @md:w-40'

/** rest:ln (mock `ln-resume`): 16 inside, the thumbnail 20 from the words. */
export const RESUME_ROW = 'flex flex-col gap-4 p-4 @md:flex-row @md:items-center @md:gap-5 @md:pr-5'
